import script from "./whDOnceImg2_t1B.vue?vue&type=script&setup=true&lang=js"
export * from "./whDOnceImg2_t1B.vue?vue&type=script&setup=true&lang=js"

import "./whDOnceImg2_t1B.vue?vue&type=style&index=0&id=4b6ae797&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b6ae797"]])

export default __exports__